export default function (axios) {
  return {
  // 获取验证码
    getCode(userLoginCode, type) {
      return axios.get("/anon/verifyCode", {
        params: { userLoginCode, verifyType: type ? type : 2 },
      });
    },
  }
}